// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__1IMjA","image":"Avatar_image__2rfjc","textAvatar":"Avatar_textAvatar__2_cl1"};